var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.downloading.message != '')?_c('div',{staticClass:"rounded",attrs:{"id":"downloading"}},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"spinner"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.downloading.message))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }